/** Anonymous fixture values used by the daily-schedule memo popup. */
export const legacyScheduleMemoToolbar = [
  '스타일', 'B', 'I', 'U', 'S', '글꼴', '색상', '목록', '문단', '표', '링크', '사진', '전체화면', '도움말',
]

export const legacyScheduleMemoInitialContent = 'Mock 메모를 입력하세요.'
